
import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import moment from 'moment';
import { Document } from '@sageworks/jpi';

export default Vue.extend({
	name: 'MarkOnFileModal',
	components: {
		FontAwesomeIcon
	},
	props: {
		documentRequestId: {
			type: Number,
			required: true
		},
		documentName: {
			type: String,
			required: true
		},
		potentialMatches: {
			type: Array as () => Document[],
			default: () => []
		},
	},
	data() {
		return {
			selectedDocumentId: null as number | null,
			markingOnFile: false
		};
	},
	computed: {
		modalId(): string {
			return `mark-on-file-modal-${this.documentRequestId}`;
		},
		modalTitle(): string {
			return this.documentName;
		}
	},
	methods: {
		onModalShown(): void {
			this.$emit('modal-shown');
		},
		onModalHidden(): void {
			this.selectedDocumentId = null;
			this.markingOnFile = false;
			this.$emit('modal-hidden');
		},
		formatDate(dateString?: string | null): string {
			if (!dateString) return '';
			return moment(dateString).format('MM/DD/YYYY');
		},
		formatFileSize(bytes: number): string {
			if (bytes === 0) return '0 Bytes';
			const k = 1024;
			const sizes = ['Bytes', 'KB', 'MB', 'GB'];
			const i = Math.floor(Math.log(bytes) / Math.log(k));
			return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
		},
		previewDocument(_: Document): void {
			// if (document.previewUrl) {
			// 	window.open(document.previewUrl, '_blank', 'noreferrer');
			// }
		},
		async confirmMarkOnFile(): Promise<void> {
			if (!this.selectedDocumentId) return;
			
			this.markingOnFile = true;
			try {
				const selectedDocument = this.potentialMatches.find(doc => doc.id === this.selectedDocumentId);
				this.$emit('mark-on-file-confirmed', {
					documentRequestId: this.documentRequestId,
					selectedDocument
				});
			} catch (error) {
				// eslint-disable-next-line no-console
				console.error('Error marking document on file:', error);
			} finally {
				this.markingOnFile = false;
			}
		}
	}
});
